/**
 * Public analytics lookup requires account context.
 * Authenticated Jepto twin: projects/jepto/src/app/features/reports/graphql/queries/get-theme.ts
 */
export const queryGetTheme = `
	query getTheme($themeId: ID, $accountId: ID) {
		getItem {
			theme(themeId: $themeId, accountId: $accountId) {
				themeId
				label
				maxWidth
				padding
				paletteId
				connectedReport
				card {
					borderRadius
					borderWidth
					padding
					shadow
					spacing
				}
				colors {
					dark {
						background
						border {
							primary
							secondary
						}
						card {
							background
							shadow
						}
						status {
							danger
							info
							success
							warning
						}
						text {
							link
							primary
							secondary
						}
					}
					light {
						background
						border {
							primary
							secondary
						}
						card {
							background
							shadow
						}
						status {
							danger
							info
							success
							warning
						}
						text {
							link
							primary
							secondary
						}
					}
				}
				typography {
					baseSize
					fontFamily
					card {
						headingWeight
						subheadingWeight
					}
					size {
						lg
						md
						sm
						xl
						xs
						xxl
						xxs
					}
					weight {
						bold
						light
						medium
						regular
						semibold
					}
				}
				palette {
					paletteId
					label
					light
					dark
					themeUsage
					reportUsage
				}
			}
		}
	}
`;
